import { ApiBaseService } from 'api/apibase.service';
import {
  Arrangement,
  ArrangementSuggestion,
} from 'redux/PDP/arrangement/types/arrangement.types';
import { ArrangementPreview, ArrangementsParams } from 'api/arrangements/types';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import { dateToSQLDateTimeString } from 'utils/date';

export const ALL_ARRANGEMENTS_FILTER_VALUE = '5';
export const VIEW_ALL_ARRANGEMENTS_FILTER_VALUE = '635';

class ArrangementApiService extends ApiBaseService {
  getArrangements(params: {
    pageFriendlyUrl?: string;
    limit?: number;
  }): Promise<Arrangement[]> {
    return this.apibase
      .get<Arrangement[]>(`/arrangement`, { params })
      .then(({ data }) => data);
  }

  getProductDetails(
    arrangementId: number,
    storeId: number,
  ): Promise<Arrangement[]> {
    return this.apibase
      .get<Arrangement[]>(
        `/arrangement/product-details/${arrangementId}/${storeId}`,
      )
      .then(({ data }) => data);
  }

  find(
    { date, ...params }: ArrangementsParams,
    config: AxiosRequestConfig = {},
  ): AxiosPromise<ArrangementPreview[]> {
    const formattedDate = date ? dateToSQLDateTimeString(date) : undefined;

    if (
      formattedDate === '0001-01-01+00:00:00' ||
      formattedDate?.includes('0001-01-01') ||
      formattedDate === '0001-01-02+00:00:00' ||
      formattedDate?.includes('0001-01-02')
    ) {
      return this.apibase.get('/arrangements', {
        ...config,
        params: {
          ...params,
        },
      });
    }
    return this.apibase.get('/arrangements', {
      ...config,
      params: {
        ...params,
        date: formattedDate,
      },
    });
  }

  getArrangementsOneHourDelivery(): Promise<number[]> {
    return this.apibase
      .get<number[]>('/products/one-hour-delivery')
      .then(({ data }) => data);
  }

  getSuggestions(arrangementId: number): Promise<ArrangementSuggestion[]> {
    return this.apibase
      .get<ArrangementSuggestion[]>(`/arrangement/${arrangementId}/suggestions`)
      .then(({ data }) => data);
  }

  getBrandSuggestions({
    brandId,
    cartRecipientId,
  }: {
    brandId: string;
    cartRecipientId: number;
  }): Promise<ArrangementSuggestion[]> {
    return this.apibase
      .get<ArrangementSuggestion[]>(`/arrangement/suggestions/brand`, {
        params: {
          brandId,
          cartRecipientId,
        },
      })
      .then(({ data }) => data);
  }
}

const arrangementApiService = new ArrangementApiService();

export { arrangementApiService };
